import PictionJS from 'piction-js';
import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { setMetaUmoId, toggleMetaPanelView } from '../../actions/mainUI';
import MetadataView from '../MetadataView/MetadataView';
import Loader from '../ui/Loader';
import UMOThumbnail from '../UMOThumbnail';
import CloseIcon from '../../../icons/sub-menu-and-common-icons/close-icon.svg';

const UMOMetadataPanel = ({ className, umo, isDataLoading, dispatch, intl }) => {
  function closePanel() {
    dispatch(setMetaUmoId(null));
    dispatch(toggleMetaPanelView(false));
  }
  let title = '';
  if (isDataLoading) {
    title = <Loader className={'dark'} />;
  } else {
    title = <h6 className="meta-panel__title">{intl.formatMessage({ id: 'metaPanel.title' })} {umo.data.n[0]}</h6>;
  }
  let combinedUmoView = '';
  if (!isDataLoading) {
    combinedUmoView = (
      <div>
        <div className="mb-4 umo-thumbnail-host">
          <UMOThumbnail umo={umo} />
        </div>
        <MetadataView
          umo={umo}
          toggleUMODetailView={closePanel}
          dispatch={dispatch}
        />
      </div>
    );
  }
  return (
    <div className={className}>
      <div className="meta-panel__height">
        <div className="meta-panel__head">
          {title}
          <img className="cross" src={CloseIcon} onClick={closePanel} />
        </div>
        {combinedUmoView}
      </div>
    </div>
  );
};

UMOMetadataPanel.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO),
  className: PropTypes.string,
  isDataLoading: PropTypes.bool,
  dispatch: PropTypes.func,
};
export default injectIntl(UMOMetadataPanel);